import axios from "./axios";

export async function fetchDiscoveryProducts({
	limit = 20,
	page = 1,
	search = "",
	category = "",
	minPrice = "",
	maxPrice = "",
	sortBy = "",
	sortOrder = ""
}: {
	limit?: number;
	page?: number;
	search?: string;
	category?: string;
	minPrice?: string;
	maxPrice?: string;
	sortBy?: string;
	sortOrder?: string;
} = {}) {
	const params: Record<string, any> = { limit, page };
	if (search)
		params.search = search;
	if (category && category !== "All")
		params.category = category;
	if (minPrice)
		params.minPrice = minPrice;
	if (maxPrice)
		params.maxPrice = maxPrice;
	if (sortBy)
		params.sortBy = sortBy;
	if (sortOrder)
		params.sortOrder = sortOrder;
	const response = await axios.get(`/product/discovery`, { params });
	return response.data;
}
